<script lang="tsx">
import { defineComponent } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table } from 'ant-design-vue'
import { renderTicketLoanCols } from './CommonCols'
const [name] = createNamespace('JtZchResettleTicketLoan')
export default defineComponent({
  name,
  setup(_, { attrs }) {
    const columns = renderTicketLoanCols(false)
    return () => <Table pagination={false} columns={columns} size='small' scroll={{ x: 'max-content' }} {...attrs} />
  }
})
</script>
